import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { Panel, Empty } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { fmtUsd, fmtDate } from '../../lib/api';

export default function History() {
  const { data: ledger } = useFetch('/account/ledger');
  const [filter, setFilter] = useState('all');
  const rows = (ledger || []).filter((l) => filter === 'all' || l.type === filter);
  const types = Array.from(new Set((ledger || []).map((l) => l.type)));

  const exportCsv = () => {
    const header = 'type,amount,ref,date\n';
    const body = rows.map((l) => `${l.type},${l.amount},${l.ref || ''},${l.created_at}`).join('\n');
    const blob = new Blob([header + body], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'veyjex-ledger.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="history-page">
      <Panel title="Account Ledger & History" action={
        <div className="flex items-center gap-2">
          <select value={filter} onChange={(e) => setFilter(e.target.value)} className="h-9 px-2 rounded-lg bg-vj-charcoal border border-border text-xs text-foreground" data-testid="history-filter">
            <option value="all">All types</option>
            {types.map((t) => <option key={t} value={t}>{t.replace(/_/g, ' ')}</option>)}
          </select>
          <button onClick={exportCsv} className="h-9 px-3 rounded-lg border border-border text-xs inline-flex items-center gap-1.5 hover:border-vj-neon/50" data-testid="history-export"><Download size={13} /> CSV</button>
        </div>
      }>
        {rows.length ? (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-vj-grey border-b border-border"><th className="py-2 font-medium">Type</th><th className="font-medium">Amount</th><th className="font-medium">Reference</th><th className="font-medium">Date</th></tr></thead>
            <tbody>{rows.map((l) => (
              <tr key={l.id} className="border-b border-border last:border-0">
                <td className="py-2.5 capitalize">{l.type.replace(/_/g, ' ')}</td>
                <td className={`font-mono ${Number(l.amount) >= 0 ? 'text-vj-neon' : 'text-vj-red'}`}>{Number(l.amount) >= 0 ? '+' : ''}{fmtUsd(l.amount)}</td>
                <td className="font-mono text-xs text-vj-grey truncate max-w-[180px]">{l.ref || '—'}</td>
                <td className="text-xs text-vj-grey">{fmtDate(l.created_at)}</td>
              </tr>
            ))}</tbody>
          </table></div>
        ) : <Empty>No ledger entries yet.</Empty>}
      </Panel>
    </div>
  );
}
